export const QUOTATION_PAGE_DIMENSIONS = {
  a4: { portrait: { width: 210, height: 297 }, landscape: { width: 297, height: 210 } },
  a5: { portrait: { width: 148, height: 210 }, landscape: { width: 210, height: 148 } },
};

const PRINT_MIN_HEIGHT_RATIO = 0.9;
export const QUOTATION_SPARSE_ITEM_THRESHOLD = 8;

export function isQuotationSparse(itemCount) {
  return (itemCount || 0) < QUOTATION_SPARSE_ITEM_THRESHOLD;
}

/** Print / Save PDF: full A4 width, ~90% min page height, details flow after table (no filler rows). */
export function buildQuotationPrintLayoutCss(rootSel, pageDims) {
  const w = pageDims.width;
  const minH = Math.round(pageDims.height * PRINT_MIN_HEIGHT_RATIO);
  const r = rootSel;
  return `
    ${r} {
      width: ${w}mm !important;
      min-width: ${w}mm !important;
      max-width: ${w}mm !important;
      min-height: ${minH}mm !important;
      height: auto !important;
      padding: 5mm !important;
      box-sizing: border-box !important;
      overflow: visible !important;
      overflow-wrap: anywhere !important;
      word-break: break-word !important;
      display: block !important;
    }
    ${r}.quotation-screen-preview-boost {
      min-height: auto !important;
      width: 100% !important;
      max-width: 100% !important;
    }
    ${r} .quotation-print-inner {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      transform: none !important;
    }
    ${r} .quotation-doc-header {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
    }
    ${r} .quotation-table-wrap {
      break-inside: auto !important;
      page-break-inside: auto !important;
      overflow: visible !important;
    }
    ${r} .quotation-post-items {
      break-inside: avoid !important;
      page-break-inside: avoid !important;
      margin-top: 4mm !important;
    }
    ${r} .quotation-items-table {
      table-layout: fixed !important;
      width: 100% !important;
      max-width: 100% !important;
      border-collapse: collapse !important;
    }
    ${r} thead { display: table-header-group !important; }
    ${r} tr {
      page-break-inside: avoid !important;
      break-inside: avoid !important;
    }
    ${r} th, ${r} td {
      padding: 7px 9px !important;
      vertical-align: middle !important;
      line-height: 1.45 !important;
      overflow: visible !important;
      word-wrap: break-word !important;
      overflow-wrap: anywhere !important;
      word-break: break-word !important;
      white-space: normal !important;
      font-size: 12px !important;
    }
    ${r} .quotation-item-measurement {
      display: block !important;
      font-size: 10px !important;
      color: #64748b !important;
      margin-top: 2px !important;
    }
    ${r} img {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
      max-width: 100% !important;
      height: auto !important;
      object-fit: contain !important;
    }
    ${r} .quotation-post-items-row {
      display: flex !important;
      flex-direction: row !important;
      gap: 10px !important;
      align-items: stretch !important;
    }
    ${r} .quotation-bank-box,
    ${r} .quotation-terms-box {
      flex: 1 1 50% !important;
      width: 50% !important;
      max-width: 50% !important;
      padding: 12px 14px !important;
      font-size: 14px !important;
      line-height: 1.5 !important;
      box-sizing: border-box !important;
    }
    ${r} .quotation-section-title {
      font-size: 16px !important;
      font-weight: 700 !important;
      margin-bottom: 8px !important;
      line-height: 1.3 !important;
    }
    ${r} .quotation-bank-line {
      font-size: 14px !important;
      margin-bottom: 5px !important;
      line-height: 1.45 !important;
    }
    ${r} .quotation-terms-body {
      font-size: 12px !important;
      line-height: 1.55 !important;
      white-space: pre-line !important;
    }
    ${r} .quotation-bank-qr {
      width: 22mm !important;
      height: 22mm !important;
      max-width: 22mm !important;
      max-height: 22mm !important;
      margin-top: 6px !important;
      object-fit: contain !important;
    }
    ${r} .quotation-signature-row {
      display: flex !important;
      flex-direction: row !important;
      justify-content: flex-end !important;
      align-items: flex-end !important;
      margin-top: 10mm !important;
      gap: 12mm !important;
    }
    ${r} .quotation-signature-block img {
      width: 18mm !important;
      height: 18mm !important;
      max-width: 18mm !important;
      max-height: 18mm !important;
      object-fit: contain !important;
    }
    ${r} .quotation-signature-label {
      font-size: 12px !important;
      margin-top: 4px !important;
      text-align: center !important;
    }
    ${r}.quotation-sparse-items .quotation-post-items {
      margin-top: 10mm !important;
      padding-top: 4mm !important;
    }
    ${r}.quotation-sparse-items .quotation-bank-box,
    ${r}.quotation-sparse-items .quotation-terms-box {
      padding: 16px 18px !important;
      min-height: 55mm !important;
    }
    ${r}.quotation-sparse-items .quotation-section-title {
      font-size: 18px !important;
      margin-bottom: 10px !important;
    }
    ${r}.quotation-sparse-items .quotation-bank-line {
      font-size: 15px !important;
      margin-bottom: 7px !important;
    }
    ${r}.quotation-sparse-items .quotation-terms-body {
      font-size: 13px !important;
      line-height: 1.6 !important;
    }
    ${r}.quotation-sparse-items .quotation-bank-qr {
      width: 30mm !important;
      height: 30mm !important;
      max-width: 30mm !important;
      max-height: 30mm !important;
    }
    ${r}.quotation-sparse-items .quotation-signature-block img {
      width: 22mm !important;
      height: 22mm !important;
      max-width: 22mm !important;
      max-height: 22mm !important;
    }
    ${r}.quotation-sparse-items .quotation-signature-label {
      font-size: 13px !important;
    }
  `;
}

/** Copy image: content height only — no min-height, no extra spacing. */
export function buildQuotationImageExportCss(rootSel) {
  const r = rootSel;
  return `
    ${r} {
      width: 210mm !important;
      max-width: 210mm !important;
      min-height: auto !important;
      height: auto !important;
      padding: 8px !important;
      box-sizing: border-box !important;
      overflow: visible !important;
      display: block !important;
    }
    ${r} .quotation-print-inner,
    ${r} .quotation-table-wrap,
    ${r} .quotation-post-items {
      display: block !important;
      min-height: auto !important;
      margin-top: 0 !important;
      flex: none !important;
    }
    ${r} .quotation-post-items {
      margin-top: 8px !important;
    }
    ${r} th, ${r} td {
      padding: 6px 8px !important;
      vertical-align: middle !important;
      line-height: 1.45 !important;
      overflow: visible !important;
    }
    ${r} .quotation-bank-box,
    ${r} .quotation-terms-box {
      min-height: auto !important;
      padding: 8px !important;
      font-size: 12px !important;
    }
    ${r} .quotation-section-title { font-size: 13px !important; }
    ${r} .quotation-bank-line { font-size: 12px !important; }
    ${r} .quotation-terms-body { font-size: 11px !important; }
    ${r} .quotation-bank-qr {
      width: 64px !important;
      height: 64px !important;
      max-width: 64px !important;
      max-height: 64px !important;
    }
    ${r} .quotation-signature-block img {
      width: 48px !important;
      height: 48px !important;
      max-width: 48px !important;
      max-height: 48px !important;
    }
  `;
}
